import { AfterViewChecked, ChangeDetectionStrategy, Component, ElementRef, input, output, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AiMessageVm } from '@domain/ai-assistant/ai-assistant.view-models';

import { AiMessageListLoadingSkeletonComponent } from '../ai-message-list-loading-skeleton/ai-message-list-loading-skeleton.component';
import { AiMessageComponent } from '../ai-message/ai-message.component';

@Component({
  selector: 'app-ai-message-list',
  imports: [AiMessageComponent, AiMessageListLoadingSkeletonComponent, TranslatePipe],
  templateUrl: './ai-message-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col grow overflow-hidden relative z-0' },
})
export class AiMessageListComponent implements AfterViewChecked {
  public readonly scrollContainer = viewChild<ElementRef<HTMLDivElement>>('scrollContainer');

  public messages = input<AiMessageVm[]>([]);
  public isStreaming = input(false);
  public showTypingIndicator = input(false);
  public showSuggestions = input(false);
  public suggestions = input<string[]>([]);
  public messagesLoading = input(false);

  private shouldAutoScroll = true;

  public suggestionClicked = output<string>();

  public onSuggestionClick(suggestionTranslation: string): void {
    this.suggestionClicked.emit(suggestionTranslation);
  }

  public ngAfterViewChecked(): void {
    if (this.shouldAutoScroll) {
      this.scrollToBottom();
    }
  }

  private scrollToBottom(): void {
    const el = this.scrollContainer()?.nativeElement;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }

  public onScroll(event: Event): void {
    const el = event.target as HTMLDivElement;
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    this.shouldAutoScroll = !distanceFromBottom;
  }
}
